import {
  convertDateToYYYYMMDDFormat,
  CustomDateRangePicker,
  FormFeedBack,
  PageWrapper,
  parseLocalDateFromYYYYMMDD,
  STATUSPAGE,
  SUBMIT_BUTTON,
} from '@repo/ui';
import { ReportsGeneralFilters } from 'presentation/app/modules/Reports/components/reports-general-filters';
import { useStudentsWorkloadAchievement } from 'presentation/app/modules/Reports/hooks/useStudentsWorkloadAchievement';
import { Card, CardBody, Col, Label, Row, Spinner } from 'reactstrap';

import { StudentsWorkloadAchievementEmptyState as EmptyState } from './components/empty-state';
import { WorkloadAchievementGroupedList } from './components/workload-achievement-grouped-list';

const StudentsWorkloadAchievement = () => {
  const {
    validation,
    tableLoading,
    buttonsLoading,
    loadingAllGroups,
    hasFetchedData,
    selectedSubmitBtnRef,
    workloadAchievementData,
  } = useStudentsWorkloadAchievement();

  const groups = workloadAchievementData.groups || [];
  const disableActions =
    tableLoading === STATUSPAGE.LOADING ||
    buttonsLoading === STATUSPAGE.LOADING;

  return (
    <PageWrapper title="Relatório Estudantes > Carga Horária Alcançada">
      <Col className="mb-3 border-0 d-flex align-items-end justify-content-between">
        <h4>Carga Horária Alcançada</h4>
      </Col>

      <Card>
        <ReportsGeneralFilters
          validation={validation}
          isGroupMulti={false}
          inputsChildren={
            <Col xs={12} md={6} lg={3} className="mb-3">
              <Row>
                <Label htmlFor="initial-date" className="form-label">
                  Período
                </Label>
                <CustomDateRangePicker
                  cleanable
                  placement="auto"
                  initialStartDate={
                    validation.values.starts
                      ? parseLocalDateFromYYYYMMDD(validation.values.starts)
                      : null
                  }
                  initialEndDate={
                    validation.values.ends
                      ? parseLocalDateFromYYYYMMDD(validation.values.ends)
                      : null
                  }
                  onDateChange={(start, ends) => {
                    validation.setFieldValue(
                      'starts',
                      start ? convertDateToYYYYMMDDFormat(start) : null,
                    );
                    validation.setFieldValue(
                      'ends',
                      ends ? convertDateToYYYYMMDDFormat(ends) : null,
                    );
                  }}
                />
                <FormFeedBack
                  error={validation.errors?.ends?.toString()}
                  isInvalid={!!(validation.touched && validation.errors?.ends)}
                />
              </Row>
            </Col>
          }
          buttonsChildren={
            <div className="d-flex gap-2 justify-content-end align-content-end">
              <button
                id="search"
                type="submit"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.JSON;
                }}
                className="btn btn-primary waves-effect waves-light"
                disabled={disableActions}
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.JSON &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar
                    <i className="ri-computer-line mx-2"></i>
                  </>
                )}
              </button>

              <button
                type="submit"
                id="export-pdf"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.PDF;
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={disableActions}
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.PDF &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Visualizar em PDF
                    <i className="las la-file-pdf mx-2"></i>
                  </>
                )}
              </button>

              <button
                id="export-excel"
                type="submit"
                onClick={() => {
                  selectedSubmitBtnRef.current = SUBMIT_BUTTON.EXCEL;
                }}
                className="btn btn-light waves-effect waves-light"
                disabled={disableActions}
              >
                {selectedSubmitBtnRef.current === SUBMIT_BUTTON.EXCEL &&
                buttonsLoading === STATUSPAGE.LOADING ? (
                  <Spinner size="sm">{['Carregando...']}</Spinner>
                ) : (
                  <>
                    Exportar para Excel
                    <i className="ri-file-excel-2-line mx-2"></i>
                  </>
                )}
              </button>
            </div>
          }
        />
      </Card>

      {!hasFetchedData && tableLoading !== STATUSPAGE.LOADING && <EmptyState />}

      {(hasFetchedData || tableLoading === STATUSPAGE.LOADING) && (
        <Card className="mt-3">
          <CardBody>
            <WorkloadAchievementGroupedList
              groups={groups}
              loading={tableLoading === STATUSPAGE.LOADING}
              loadingTotal={loadingAllGroups}
            />
          </CardBody>
        </Card>
      )}
    </PageWrapper>
  );
};

export default StudentsWorkloadAchievement;
